var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailOtpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 59,
    viewBox: "0 0 76 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.0788 33.0684C39.4302 33.0684 40.8155 32.3589 42.2345 30.9399L71.6287 1.84976C70.3673 0.655976 68.0586 0.059082 64.7025 0.059082H10.3063C7.4457 0.059082 5.46356 0.610927 4.35987 1.71462L33.923 30.9399C35.3195 32.3589 36.7048 33.0684 38.0788 33.0684ZM1.5556 52.8335L25.4426 29.2168L1.48803 5.60006C0.969967 6.5686 0.710938 8.20162 0.710938 10.4991V47.7993C0.710938 50.1869 0.992491 51.865 1.5556 52.8335ZM11.3199 58.2731H65.7161C68.5316 58.2731 70.5025 57.7326 71.6287 56.6514L47.2687 32.5279L45.0388 34.7916C42.7638 36.9539 40.4438 38.0351 38.0788 38.0351C35.6912 38.0351 33.3712 36.9539 31.1187 34.7916L28.855 32.5279L4.56259 56.6176C5.84648 57.7213 8.09891 58.2731 11.3199 58.2731ZM74.5005 52.7997C75.0411 51.8087 75.3114 50.1419 75.3114 47.7993V10.4991C75.3114 8.22414 75.0637 6.62492 74.5681 5.70142L50.6811 29.2168L74.5005 52.7997Z",
    fill: "#48D38A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailOtpIcon);
export default __webpack_public_path__ + "static/media/emailOtpIcon.0d7ce9628bd0a99c9402638a1fa19caa.svg";
export { ForwardRef as ReactComponent };